const functions = {
    availableMethods() {
        return [
            'getOne',
            'updateOne',
            'updateLetterheadTemplate',
            'updateLetterheadOptions',
            'updateLetterhead'
        ];
    },

    updateLetterheadTemplate(lawFirmId, template) {
        const url = `${this.modelName}/${lawFirmId}/update-letterhead-template`;

        return this._callApi(url, 'post', { template });
    },

    updateLetterheadOptions(lawFirmId, template, options) {
        const url = `${this.modelName}/${lawFirmId}/update-letterhead-options`;

        return this._callApi(url, 'post', { template, options });
    },

    updateLetterhead(lawFirmId, template, letterhead) {
        const url = `${this.modelName}/${lawFirmId}/update-letterhead`;

        return this._callApi(url, 'post', { template, letterhead });
    }
};

export default functions;
